import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { editCriteriaTerms } from '../../constants/suggestedAgents';
import { modules } from '../../../constants/index';
import { getPropertyTypeTitle } from '../../../common/helpers/titles';
import PropertyType from '../../../common/components/search/menus/PropertyType';

const PropertyTypeDropdown = ({ mlsPropertyTypes, selectedPropertyTypes, onPropertyTypesChange, onRegisterClose }) => {
    const [isPropertyTypeOpen, setIsPropertyTypeOpen] = useState(false);
    const hasPropertyTypes = mlsPropertyTypes.length > 0;

    const buttonLabel = useMemo(() => {
        const selectedAsStrings = selectedPropertyTypes.map(id => id.toString());
        return getPropertyTypeTitle(mlsPropertyTypes, selectedAsStrings).mainTitle;
    }, [selectedPropertyTypes, mlsPropertyTypes]);

    const toggle = () => setIsPropertyTypeOpen(prev => !prev);

    onRegisterClose?.(() => setIsPropertyTypeOpen(false));

    return (
        <Dropdown
            isOpen={isPropertyTypeOpen}
            toggle={toggle}
            className="w-100"
            inNavbar
        >
            <DropdownToggle
                id="prop-type-btn"
                dataLwtId="edit-criteria-property-types"
                tag="button"
                type="button"
                className={`prop-type-btn btn btn-outline-secondary w-100 text-left d-flex justify-content-between align-items-center ${isPropertyTypeOpen ? 'is-open' : ''}`}
                disabled={!hasPropertyTypes}
                caret
            >
                <span className={selectedPropertyTypes?.length ? '' : 'text-muted'}>
                    {buttonLabel}
                </span>
            </DropdownToggle>

            <DropdownMenu className="w-100 p-2 mt-2 border no-transition">
                <label className="d-block mb-2">
                    {editCriteriaTerms.propertyTypesLabel}
                </label>
                <PropertyType
                    module={modules.proficiencyMetrics.suggestedAgents}
                    initialPropTypes={selectedPropertyTypes.map(id => Number(id))}
                    setPropTypes={(ids) => hasPropertyTypes && onPropertyTypesChange(ids)}
                    toggleInvalid={() => {}}
                    invalid={false}
                    propTypes={mlsPropertyTypes}
                />
            </DropdownMenu>
        </Dropdown>
    );
};

PropertyTypeDropdown.propTypes = {
    mlsPropertyTypes: PropTypes.array.isRequired,
    selectedPropertyTypes: PropTypes.array.isRequired,
    onPropertyTypesChange: PropTypes.func.isRequired,
    onRegisterClose: PropTypes.func,
};

export default PropertyTypeDropdown;
